(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-bestseller-moving"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-bestseller-moving')) {
    customElements.define(
      'ph-bestseller-moving',
      class PhBestsellerMoving extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.ph-bsm__track');
          if (!this.track) return;

          this.step = () => {
            const item = this.track.querySelector('.ph-bsm__item');
            if (!item) return this.track.clientWidth;
            const gap = parseInt(getComputedStyle(this.track).columnGap, 10) || 15;
            return item.getBoundingClientRect().width + gap;
          };

          const prev = this.querySelector('[data-ph-bsm-prev]');
          const next = this.querySelector('[data-ph-bsm-next]');
          if (prev) {
            prev.addEventListener('click', () => {
              this.pauseFor(4000);
              this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
            });
          }
          if (next) {
            next.addEventListener('click', () => {
              this.pauseFor(4000);
              this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
            });
          }

          /* Everything below only exists for the optional auto-scroll. */
          this.speed = parseFloat(this.dataset.autoscroll || '0');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.speed || reducedMotion) return;

          this.visible = false;
          this.hovered = false;
          this.pausedUntil = 0;
          this.raf = null;
          this.cloned = false;
          this.setWidth = 0;
          this.wrapAt = Infinity;
          this.canScroll = false;
          this.tick = this.tick.bind(this);

          /* Animate ONLY while the section is (nearly) on screen. */
          this.io = new IntersectionObserver(
            (entries) => {
              this.visible = entries[0].isIntersecting;
              this.update();
            },
            { rootMargin: '50px' }
          );
          this.io.observe(this);

          const viewport = this.querySelector('.ph-bsm__viewport');
          viewport.addEventListener('pointerenter', () => { this.hovered = true; this.update(); });
          viewport.addEventListener('pointerleave', () => { this.hovered = false; this.update(); });
          viewport.addEventListener('focusin', () => { this.hovered = true; this.update(); });
          viewport.addEventListener('focusout', () => { this.hovered = false; this.update(); });
          viewport.addEventListener('touchstart', () => this.pauseFor(4000), { passive: true });
          viewport.addEventListener('wheel', () => this.pauseFor(4000), { passive: true });

          /*
          Seamless loop for MANUAL scrolling too: past one full item set the
          content is identical, so jumping back by exactly one set width is
          invisible. (While auto-scrolling, tick() does the same wrap.)
          */
          this.track.addEventListener(
            'scroll',
            () => {
              if (!this.raf && this.setWidth && this.track.scrollLeft >= this.wrapAt) {
                this.track.scrollLeft -= this.setWidth;
              }
            },
            { passive: true }
          );

          this.onResize = () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => this.refresh(), 150);
          };
          window.addEventListener('resize', this.onResize);

          this.refresh();
        }

        disconnectedCallback() {
          if (this.raf) cancelAnimationFrame(this.raf);
          if (this.io) this.io.disconnect();
          if (this.onResize) window.removeEventListener('resize', this.onResize);
          clearTimeout(this.resizeTimer);
          clearTimeout(this.resumeTimer);
        }

        /*
        (Re)checks whether the original items overflow the row. Only then the
        item set is duplicated once (for the endless loop) and the animation
        may run - the same condition under which Liquid shows the arrows.
        */
        refresh() {
          const items = this.track.querySelectorAll('.ph-bsm__item:not([data-ph-bsm-clone])');
          if (items.length < 2) return;

          const trackRect = this.track.getBoundingClientRect();
          const firstRect = items[0].getBoundingClientRect();
          const lastRect = items[items.length - 1].getBoundingClientRect();
          const start = firstRect.left - trackRect.left + this.track.scrollLeft;
          const end = lastRect.right - trackRect.left + this.track.scrollLeft;

          this.canScroll = end > this.track.clientWidth + 1;

          if (this.canScroll && !this.cloned) {
            items.forEach((item) => {
              const clone = item.cloneNode(true);
              clone.setAttribute('data-ph-bsm-clone', '');
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
              this.track.appendChild(clone);
            });
            this.cloned = true;
          } else if (!this.canScroll && this.cloned) {
            this.track.querySelectorAll('[data-ph-bsm-clone]').forEach((clone) => clone.remove());
            this.cloned = false;
            this.track.scrollLeft = 0;
          }

          if (this.cloned) {
            const firstClone = this.track.querySelector('[data-ph-bsm-clone]');
            this.setWidth = firstClone.getBoundingClientRect().left - firstRect.left;
            this.wrapAt = start + this.setWidth;
          } else {
            this.setWidth = 0;
            this.wrapAt = Infinity;
          }

          this.update();
        }

        pauseFor(ms) {
          this.pausedUntil = Date.now() + ms;
          this.update();
          clearTimeout(this.resumeTimer);
          this.resumeTimer = setTimeout(() => this.update(), ms + 20);
        }

        /* Starts/stops the rAF loop; no script runs while stopped. */
        update() {
          const paused = this.hovered || Date.now() < this.pausedUntil;
          const shouldRun = this.visible && !paused && this.canScroll;
          if (shouldRun && !this.raf) {
            this.lastTime = performance.now();
            this.pos = this.track.scrollLeft;
            this.raf = requestAnimationFrame(this.tick);
          } else if (!shouldRun && this.raf) {
            cancelAnimationFrame(this.raf);
            this.raf = null;
          }
        }

        tick(time) {
          if (!this.raf) return;
          /* Cap dt so returning from a background tab doesn't jump. */
          const dt = Math.min((time - this.lastTime) / 1000, 0.1);
          this.lastTime = time;
          this.pos += this.speed * dt;
          if (this.pos >= this.wrapAt) this.pos -= this.setWidth;
          this.track.scrollLeft = this.pos;
          this.raf = requestAnimationFrame(this.tick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-bestseller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-bestseller')) {
    customElements.define(
      'ph-bestseller',
      class PhBestseller extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.ph-bestseller__track');
          if (!this.track) return;

          this.prevBtn = this.querySelector('[data-ph-bs-prev]');
          this.nextBtn = this.querySelector('[data-ph-bs-next]');

          this.step = () => {
            const item = this.track.querySelector('.ph-bestseller__item');
            if (!item) return this.track.clientWidth;
            const gap = parseInt(getComputedStyle(this.track).columnGap, 10) || 15;
            return item.getBoundingClientRect().width + gap;
          };

          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
              this.track.scrollBy({ left: -this.step(), behavior: 'smooth' });
            });
          }
          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
              this.track.scrollBy({ left: this.step(), behavior: 'smooth' });
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-slideshow')) {
    customElements.define(
      'ph-slideshow',
      class PhSlideshow extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.ph-slideshow__slide'));
          this.dots = Array.from(this.querySelectorAll('.ph-slideshow__dot'));
          this.index = 0;
          this.timer = null;

          if (this.slides.length <= 1) return;

          this.dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
              this.goTo(i);
              this.restart();
            });
          });

          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          document.addEventListener('visibilitychange', () => {
            document.hidden ? this.stop() : this.start();
          });

          this.start();
        }

        disconnectedCallback() {
          this.stop();
        }

        goTo(i) {
          this.slides[this.index].classList.remove('is-active');
          this.slides[this.index].setAttribute('aria-hidden', 'true');
          if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');

          this.index = (i + this.slides.length) % this.slides.length;

          this.slides[this.index].classList.add('is-active');
          this.slides[this.index].removeAttribute('aria-hidden');
          if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
        }

        start() {
          if (this.dataset.autoplay !== 'true' || this.timer) return;
          const interval = parseInt(this.dataset.interval, 10) || 6000;
          this.timer = setInterval(() => this.goTo(this.index + 1), interval);
        }

        stop() {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }

        restart() {
          this.stop();
          this.start();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
